var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 2.08337C13.0753 2.08337 13.5417 2.54975 13.5417 3.12504V13.5417C13.5417 14.117 13.0753 14.5834 12.5 14.5834C11.9247 14.5834 11.4583 14.117 11.4583 13.5417V3.12504C11.4583 2.54975 11.9247 2.08337 12.5 2.08337ZM9.23501 5.80163C9.52307 6.29961 9.35291 6.93683 8.85493 7.2249C6.67272 8.48724 5.20833 10.8441 5.20833 13.5417C5.20833 17.5688 8.47293 20.8334 12.5 20.8334C16.5271 20.8334 19.7917 17.5688 19.7917 13.5417C19.7917 10.8441 18.3273 8.48724 16.1451 7.2249C15.6471 6.93683 15.477 6.29961 15.765 5.80163C16.053 5.30366 16.6903 5.13349 17.1882 5.42155C19.9877 7.04096 21.875 10.0703 21.875 13.5417C21.875 18.7194 17.6777 22.9167 12.5 22.9167C7.32233 22.9167 3.125 18.7194 3.125 13.5417C3.125 10.0703 5.01227 7.04096 7.81174 5.42155C8.30972 5.13349 8.94694 5.30366 9.23501 5.80163Z",
    fill: "#A6AEC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.fda65b2b224c7afa4535b79209fd4794.svg";
export { ForwardRef as ReactComponent };